export const nullUUID =  '00000000-0000-0000-0000-000000000000'

export function isUuidTruthy(uuid: string) {
    return uuid && uuid.length > 0 && uuid !== nullUUID
}